

import React, { useEffect, useState, useCallback, useMemo } from "react";
import Card from "components/card";
import Chart from "react-apexcharts";
import axios from "axios";
import { API_BASE_URL } from "../../../../config";

const SummaryDonutCard = () => {
  const [chartSeries, setChartSeries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [type, setType] = useState("monthly"); // daily, weekly, monthly

  // Fixed color map for each category (memoized to avoid re-creation)
  const categoryColors = useMemo(
    () => ({
      "Ringing/Busy": "#d37018ff",
      "Call back": "#3b82f6",
      "Cost Sheet Share": "#6b7280",
      "Visit schedule": "#fbbf24",
      "Not Interested": "#10b981",
      "Booking Done": "#ef4444",
      "Visit Done": "#2563eb",
      Other: "#8b5cf6",
    }),
    []
  );

  const chartOptions = {
    chart: { type: "donut" },
    labels: categories,
    colors: categories.map((c) => categoryColors[c] || "#a1a1aa"),
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(0)}%`,
      style: { fontSize: "13px", fontWeight: "bold" },
    },
    legend: { show: false },
    stroke: { width: 0 },
  };

  const fetchData = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const params = { type };

      const response = await axios.get(
        `${API_BASE_URL}/api/customer/total-feedbackcategory-stats`,
        {
          params,
          headers: { token },
        }
      );

      if (response.data.success) {
        const stats = response.data.result.stats;
        const total = response.data.result.totalRecords;

        // Ensure all categories are present
        const allCats = Object.keys(categoryColors);

        setCategories(allCats);
        setChartSeries(
          allCats.map((cat) => {
            const found = stats.find((s) => s.category === cat);
            return found ? (total ? (found.total / total) * 100 : 0) : 0;
          })
        );
      }
    } catch (error) {
      // console.error("Error fetching feedback stats:", error);
    }
  }, [type, categoryColors]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Card extra="rounded-[20px] p-4">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Customer Feedback Statistics
        </h4>

        {/* Dropdown for filter */}
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="text-sm border border-gray-200 rounded-md px-3 py-1.5 bg-white focus:outline-none focus:ring-1 focus:ring-yellow-400 focus:border-yellow-400 text-gray-600"
        >
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>

      <div className="flex flex-row items-center">
        {/* Legend */}
        <div className="flex flex-col space-y-2 w-1/3">
          {categories.map((cat, index) => (
            <div key={index} className="flex items-center">
              <span
                className="h-3 w-3 rounded-full mr-2"
                style={{ backgroundColor: categoryColors[cat] }}
              />
              <p className="text-sm text-gray-600">{cat}</p>
            </div>
          ))}
        </div>

        {/* Donut Chart */}
        <div className="w-2/3 flex justify-center">
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="donut"
            width="260"
          />
        </div>
      </div>
    </Card>
  );
};

export default SummaryDonutCard;




